export default function (http,baseUrl,uploadUrl) {
    return {
      addBookSale(params) {
        console.log(uploadUrl)
        console.log("param:"+params.cover)
        return http.put(`${baseUrl}/book/sale/add`, params);
      }
    }
}